export { Tab as BreadcrumbTab, TabsBreadcrumbLayoutComponent, TAB_DEPENDENCIES } from './tabs-breadcrumb.component';
export * from './tabs-breadcrumb.module';
export * from './tabs-breadcrumb.service';
